import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { NumberInputFieldWUT } from '../../../ui/number-input-field';
export const DextNumberInputWUT = props => {
  const fieldType = FIELD_TYPES.DEXT_NUMBER_INPUT;
  return /*#__PURE__*/React.createElement(NumberInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=dext-number-input-wut.js.map